"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ASYNC_TASK_NAMES () {
        return ASYNC_TASK_NAMES;
    },
    get AsyncTaskModel () {
        return AsyncTaskModel;
    },
    get AsyncTaskStatusEnum () {
        return AsyncTaskStatusEnum;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ASYNC_TASK_NAMES = {
    BULK_FEEDBACK: "bulk-feedback",
    BULK_FEEDBACK_REQUEST: "bulk-feedback-request",
    EXPORT_COMPANY_MEETINGS_CSV: "export-company-meetings-csv",
    EXPORT_WORKSPACE_MEETINGS_CSV: "export-workspace-meetings-csv",
    GENERATE_REVIEW_CYCLE_INSIGHTS: "generate-review-cycle-insights",
    GENERATE_SURVEY_INSIGHTS: "generate-survey-insights",
    PROCESS_DOCUMENT_EMBEDDINGS: "process-document-embeddings",
    ADD_SUBJECTS_TO_REVIEW_CYCLE: "add-subjects-to-review-cycle",
    CREATE_REVIEW_CYCLE: "create-review-cycle",
    REGENERATE_SYNTHETIC_EMAILS: "regenerate-synthetic-emails",
    EXPORT_COMPETENCY_ASSIGNMENTS_CSV: "export-competency-assignments-csv",
    EXPORT_GOALS_CSV: "export-goals-csv",
    IMPORT_FIELD_HISTORY: "import-field-history",
    IMPORT_COMPETENCY_DOCUMENT: "import-competency-document"
};
const AsyncTaskStatusEnum = _zod.z.enum([
    "queued",
    "processing",
    "completed",
    "failed"
]);
const AsyncTaskModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    companyId: _zod.z.instanceof(_bson.ObjectId),
    userId: _zod.z.instanceof(_bson.ObjectId).nullable(),
    status: AsyncTaskStatusEnum,
    createdAt: _zod.z.date().default(()=>new Date()),
    startedAt: _zod.z.date().nullable(),
    completedAt: _zod.z.date().nullable(),
    progressCount: _zod.z.number(),
    progressTotal: _zod.z.number(),
    metadata: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    error: _zod.z.string().nullish()
});
